import { Injectable, inject, signal } from '@angular/core';
import { UserApi } from '@app/data/api';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PromptSuggestionPreferenceService {
  private readonly userApi = inject(UserApi);
  private readonly enabledSignal = signal(true);
  private loadPromise: Promise<void> | null = null;

  readonly enabled = this.enabledSignal.asReadonly();

  setEnabled(enabled: boolean): void {
    this.enabledSignal.set(enabled);
  }

  async load(forceRefresh = false): Promise<void> {
    if (!forceRefresh && this.loadPromise) {
      return this.loadPromise;
    }

    this.loadPromise = (async () => {
      try {
        const personalization = await firstValueFrom(this.userApi.getPersonalization());
        this.enabledSignal.set(personalization?.promptSuggestionsEnabled === true);
      } catch {
        this.enabledSignal.set(false);
      } finally {
        this.loadPromise = null;
      }
    })();

    return this.loadPromise;
  }
}